import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AuthFacade } from 'src/app/ngrx/auth/auth.facade';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { GlobalService } from 'src/app/services/global.service';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-session-expired-modal',
  templateUrl: './session-expired-modal.component.html',
  styleUrls: ['./session-expired-modal.component.scss']
})
export class SessionExpiredModalComponent implements OnInit {

  title: string;
  password: string;
  invalidMsg = [];
  constructor(
    public bsModalRef: BsModalRef,
    private authService: AuthenticationService,
    public storage: StorageService,
    private global: GlobalService,
    private authFacade: AuthFacade,
  ) { }

  ngOnInit() {
  }

  closeModal() {
    this.bsModalRef.hide();
  }

  login() {
    const payload = {
      username: this.storage.getLocalValue('selectedAssignedAgentUserName'),
      password: this.password,
      grant_type: 'password',
	    edirect_uri: location.origin
    };

    this.authService.processLogin(payload).subscribe(data => {
      this.global.deleteExpiredData();
      if (data.error !== undefined) {
        this.invalidMsg.push({
          type: 'danger',
          msg: data.error.error_description !== undefined ? data.error.error_description : 'Network Error!',
          timeout: 5000
        });
      } else {
        this.authFacade.insertDataToDB(data);
        this.storage.setLocalValue('selectedAssignedAgentId', data.agent_id);
        this.storage.setLocalValue('selectedAssignedAgentUserName', payload.username);
        this.storage.setLocalValue('selectedAssignedAgentLastName', data.last_name);
        this.storage.setLocalValue('selectedAssignedAgentFirstName', data.first_name);
        setTimeout(() => { location.reload(); }, 500);
      }
    });
  }

  logout() {
    this.closeModal();
    this.authService.logout();
  }

}
